import axios from 'axios';

let prefix = "/user"
let prefix_auth = "/auth"

const UserApi = {

	getUserList(payload) {
		return axios.get(prefix + "/list", { params: payload })
	},
	searchUser(payload) {
		return axios.get(prefix + "/search", { params: payload })
	},
	getLockUserList(payload) {
		return axios.get(prefix + "/lock-list", { params: payload })
	},
	getUserCountryList(payload) {
		return axios.get(prefix + "/list-country", { params: payload })
	},
	exportUserCountryList(payload) {
		return axios.get(prefix + "/export-list-country", { params: payload })
	},
	getUserCityList(payload) {
		return axios.get(prefix + "/list-city", { params: payload })
	},
	getAvailableUplineReferralCode(payload) {
		return axios.get(prefix + "/get-available-upline-referral-code", { params: payload })
	},
	exportUserCityList(payload) {
		return axios.get(prefix + "/export-list-city", { params: payload })
	},
	exportUserList(payload) {
		return axios.get(prefix + "/export-user-list", { params: payload })
	},
	changePassword(payload) {
		return axios.post(prefix + "/profile-password/update", payload)
	},
	updateUserProfile(payload) {
		return axios.post(prefix_auth + "/update-profile", payload)
	},
	forgotPassword(payload) {
		return axios.post(prefix_auth + "/reset-password", payload)
	},
	verifyEmail(payload) {
		return axios.post(prefix + "/verifyEmailToken", payload)
	},
	getUserInfo(id, payload) {
		return axios.get(prefix + "/get/" + id, { params: payload })
	},
	createUser(payload) {
		return axios.post(prefix + "/create", payload)
	},
	updateUser(payload) {
		return axios.post(prefix + "/update", payload)
	},
	createVendor(payload) {
		return axios.post(prefix + "/create-vendor", payload)
	},
	updateVendor(payload) {
		return axios.post(prefix + "/update-vendor", payload)
	},
	archiveUser(payload) {
		return axios.delete(prefix + "/delete", { params: payload })
	},
	updateUserPassword(payload) {
		return axios.post(prefix + "/password/update", payload)
	},
	sendAccountActivation(payload) {
		return axios.post(prefix + "/activation-email/send", payload)
	},
	updateRole(payload) {
		return axios.post(prefix + "/update-role", payload)
	},
	createStaff(payload) {
		return axios.post(prefix + "/create-staff", payload)
	},
	updateStaff(payload) {
		return axios.post(prefix + "/update-staff", payload)
	},
	getUserByQrCode(id, payload) {
		return axios.get(prefix + "/get-by-qrcode/" + id, { params: payload })
	},
	unlockAccount(payload) {
		return axios.post(prefix + "/unlock-account", payload)
	},
	createBrandOwner(payload) {
		return axios.post(prefix + "/create-brand-owner", payload)
	},
	updateBrandOwner(payload) {
		return axios.post(prefix + "/update-brand-owner", payload)
	},
	createLocationOwner(payload) {
		return axios.post(prefix + "/create-location-owner", payload)
	},
	updateLocationOwner(payload) {
		return axios.post(prefix + "/update-location-owner", payload)
	},
	createAgent(payload) {
		return axios.post(prefix + "/create-agent", payload)
	},
	updateAgent(payload) {
		return axios.post(prefix + "/update-agent", payload)
	},
	getOwnerOptions(payload) {
		return axios.get(prefix + "/owner-options", { params: payload })
	},
	getTenantsByOwner(payload) {
		return axios.get(prefix + "/tenants-by-owner", { params: payload })
	},
	linkTenants(payload) {
		return axios.post(prefix + "/link-tenants", payload)
	},
	createBrandCentre(payload) {
		return axios.post(prefix + "/create-brand-centre", payload)
	},
	listBrandCentre(payload) {
		return axios.get(prefix + "/list-brand-centre", { params: payload })
	},
	updateBrandCentre(payload) {
		return axios.put(prefix + "/update-brand-centre/" + payload.id, payload)
	},
	deleteBrandCentre(id) {
		return axios.delete(prefix + "/delete-brand-centre/" + id)
	},
	bulkUploadVendor(payload, onUploadProgress = {} ){
		return axios.post(prefix + "/upload-vendor", payload,{
			headers: { 'Content-Type': 'multipart/form-data'},
			onUploadProgress
		})
	},
	getVendorQrCodePng(id, payload) {
		return axios.get(prefix + "/vendor-qrcode-png/" + id, { params: payload })
	},
	exportSingleVendorQrCodePdf(id) {
		return axios.get(prefix + "/vendor-qrcode-pdf/" + id, { responseType: 'blob' })
	},
	exportVendorQrCodesPdf(payload) {
		return axios.get(prefix + "/export-vendor-qrcodes-pdf", {
			params: payload,
			responseType: 'blob',
		})
	},
}

export default UserApi;